import styled from 'styled-components'

export const AudienceIndicators = styled.span`
  position: ${({ inline }) => inline ? 'static' : 'absolute'};
  top: ${({ belowFavorite, belowTopMeta }) => belowFavorite ? '56px' : belowTopMeta ? '52px' : '8px'};
  right: 12px;
  z-index: 9;
  display: flex;
  flex-direction: ${({ inline }) => inline ? 'row' : 'column'};
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ inline }) => inline ? '6px' : '4px'};
  max-width: 100%;
  pointer-events: none;

  @media (max-width: 480px) {
    top: ${({ belowFavorite, belowTopMeta }) => belowFavorite ? '56px' : belowTopMeta ? '52px' : '8px'};
    right: 8px;
  }
`

export const AudienceIndicator = styled.span`
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.palette.colors.mediaControlBorder};
  border-radius: 999px;
  background: ${({ theme }) => theme.palette.colors.mediaControlBackground};
  box-shadow: 0 6px 16px ${({ theme }) => theme.palette.colors.shadowStrong};
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  cursor: help;
  pointer-events: auto;
  transition: transform 0.18s ease, background 0.18s ease, border-color 0.18s ease;

  &:hover {
    transform: scale(1.06);
    border-color: ${({ theme }) => theme.palette.colors.mediaControlBorderStrong};
    background: ${({ theme }) => theme.palette.colors.mediaControlBackgroundStrong};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.blue.main};
    outline-offset: 2px;
    box-shadow: 0 0 0 3px ${({ theme }) => theme.palette.colors.mediaControlBackgroundStrong};
  }

`

export const AudienceIcon = styled.img.attrs(({ icon }) => ({
  src: `/icons/${icon}.png`,
}))`
  width: 30px;
  height: 30px;
  display: block;
  object-fit: contain;
  pointer-events: none;
`
